import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#2C97DE",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "m16 9.733-1.567 1.091.553-1.828-1.522-1.153 1.909-.04L16 6l.627 1.804 1.91.039-1.522 1.153.552 1.828zM8.852 17.05l-1.354 1.347.227-1.896-1.7-.872 1.874-.37.305-1.885.93 1.667 1.887-.293-1.298 1.4.862 1.704zm14.296 0-1.733.802.862-1.704-1.298-1.4 1.887.293.93-1.667.305 1.885 1.873.37-1.699.872.228 1.896zM16 22.267l-1.567-1.091.553 1.828-1.522 1.153 1.909.04L16 26l.627-1.804 1.91-.039-1.522-1.153.552-1.828z",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagFsm = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagFsm_default = SvgFlagFsm;

export { FlagFsm_default as default };
